import { FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';

export abstract class MetricFilter<T> {
  constructor(public values?: T[]) {}

  public abstract field: string;
  public abstract operator: FilterOperator;

  public abstract needsRequest(newQueryBuilder: QueryBuilder): boolean;
  public abstract merge(newFilter: MetricFilter<T>): MetricFilter<T>;
  public abstract filterMetrics<K extends MetricView>(metrics: K[]): K[];

  public value(): string | undefined {
    if (!this.values) return undefined;
    return this.values.join();
  }

  protected areValuesIncluded(newFilter?: MetricFilter<unknown>): boolean {
    if (!this.values) return true;
    if (!newFilter || !newFilter.values) return false;
    return newFilter.values.every((newValue) => this.values.includes(newValue as T));
  }
}
